export const StepNavContainer = ({ children, className }: any) => {
    return (
        <div className={className || 'mb-8'}>
            {children}
        </div>
    )
}